var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

var FAQ = function () {
    this.$faqTitles = document.querySelectorAll( '.module-faq__item-title' );
};

FAQ.prototype.init = function () {
	var self = this;

	$( self.$faqTitles ).each(
		function () {
			$( this ).click(
				function (e) {
					e.preventDefault();
					$( this ).parent().find( '.module-faq__item-content' ).stop().slideToggle( 'fast' );
					$( this ).find( '.module-faq__icon--down' ).toggle();
					$( this ).find( '.module-faq__icon--up' ).toggle();
				}
			);
		}
	);
};

module.exports = new FAQ();
